export default "<footer *ngIf=\"footer\" class=\"footer-env\">\n  <p>{{ texto }}</p>\n</footer>"